import { BrowserRouter } from 'react-router-dom';
import { Flip, ToastContainer } from 'react-toastify';

import { useAppSelector } from '../store/hooks';
import AppRoute from './AppRoute';
import AuthRouter from './AuthRouter';

export const MainRouter = () => {
  const { key } = useAppSelector((state) => state.session)

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-center"
        hideProgressBar
        newestOnTop={true}
        rtl={false}
        draggable={true}
        theme="light"
        transition={Flip}
        pauseOnHover
      />
      {key ? <AppRoute /> : <AuthRouter />}
    </BrowserRouter>
  )
}
